/** App Suites API. The effective read is only called when the feature flag is on. */

import type {
  AppSuiteEffective,
  AppSuiteSettingsAdminRead,
  AppSuiteSettingsUpdate,
} from '../../types/appSuites'
import { request } from './core'

export const appSuitesApi = {
  getEffective: () => request<AppSuiteEffective>('/v1/app-suites'),
}

export const platformAppSuitesApi = {
  get: () => request<AppSuiteSettingsAdminRead>('/v1/platform-admin/app-suites'),

  put: (body: AppSuiteSettingsUpdate) =>
    request<AppSuiteSettingsAdminRead>('/v1/platform-admin/app-suites', {
      method: 'PUT',
      body: JSON.stringify(body),
    }),

  reset: () =>
    request<AppSuiteSettingsAdminRead>('/v1/platform-admin/app-suites', {
      method: 'DELETE',
    }),
}
